import graphql__40d9d1166afcc33353df from "./__generated__/ConfigureSupplierDialogAssignAmountEstimateSourceMutation.graphql.ts";import * as React from "react";
import {graphql} from "react-relay";
import {useRelayEnvironment} from "react-relay/hooks";
import {useIntl} from "react-intl";
import FormDialog from "./FormDialog";
import Section from "../form/Section";
import Row from "../form/Row";
import Label from "../form/Label";
import Field from "../form/Field";
import {AMOUNT_ESTIMATE_SOURCES, AmountEstimateSource} from "../../helper/expenseLabels";
import {commitMutationWithErrorHandling} from "../../helper/commitMutationWithErrorHandling";
import {useErrorContext} from "../../contexts/ErrorContext";
import type {ConfigureSupplierDialogAssignAmountEstimateSourceMutation} from "./__generated__/ConfigureSupplierDialogAssignAmountEstimateSourceMutation.graphql";

type Props = {
    supplier: {
        supplierIdentifier: string
        name: string
        amountEstimateSource: string | null | undefined
    }
    onClose: () => void
}

/**
 * The settings of a supplier which are rarely changed. So far only the source the forecast
 * estimates the supplier's amounts from; each further setting gets a row of its own.
 */
const ConfigureSupplierDialog: React.FC<Props> = ({supplier, onClose}) => {
    const intl = useIntl();
    const relayEnvironment = useRelayEnvironment();
    const {addError} = useErrorContext();

    const handleSubmission = (values: {amountEstimateSource: string}) => {
        commitMutationWithErrorHandling<ConfigureSupplierDialogAssignAmountEstimateSourceMutation>(
            relayEnvironment,
            {
                mutation: graphql__40d9d1166afcc33353df,
                variables: {input: {id: supplier.supplierIdentifier, amountEstimateSource: values.amountEstimateSource === '' ? null : values.amountEstimateSource as AmountEstimateSource}},
                onCompleted: () => onClose(),
                onError: () => onClose(),
            },
            addError,
            {customErrorMessage: intl.formatMessage({id: 'errors.failedToAssignSupplierAmountEstimateSource'})}
        );
    };

    return (
        <FormDialog handleCloseDialog={onClose}
                    handleSubmission={handleSubmission}
                    initialValues={{amountEstimateSource: supplier.amountEstimateSource ?? ''}}
                    headline={intl.formatMessage({id: 'dialog.ConfigureSupplierDialog.headline'}, {name: supplier.name})}
                    submitLabel={intl.formatMessage({id: 'button.save'})}>
            <Section>
                <Row>
                    <Label>{intl.formatMessage({id: 'dialog.ConfigureSupplierDialog.amountEstimateSourceLabel'})}</Label>
                    <Field name="amountEstimateSource" as="select">
                        <option value="">{intl.formatMessage({id: 'dialog.ConfigureSupplierDialog.noAmountEstimateSource'})}</option>
                        {AMOUNT_ESTIMATE_SOURCES.map(source => (
                            <option key={source} value={source}>{intl.formatMessage({id: `expense.amountEstimateSource.${source}`})}</option>
                        ))}
                    </Field>
                    <p className="mt-2 text-sm text-gray-500">{intl.formatMessage({id: 'dialog.ConfigureSupplierDialog.amountEstimateSourceHint'})}</p>
                </Row>
            </Section>
        </FormDialog>
    );
};

export default ConfigureSupplierDialog;
